<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          Annotation Work Form
        </v-card-title>
        <v-tabs
        grow
        icons-and-text
        dark
        slider-color="grey lighten-4"
        color="primary"
        v-model="step">
          <v-tab ripple>
            General Info
          </v-tab>
          <v-tab ripple :disabled="isNew">
            Annotation Tasks
          </v-tab>
        </v-tabs>
        <v-card-text>
          <v-tabs-items v-model="step">
            <v-tab-item class="mt-4">
              <form>
                <v-layout row>
                  <v-flex xs6>
                    <v-text-field
                    disabled
                    v-model="item.id"
                    label="ID">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    disabled
                    v-model="item.createdDate"
                    label="Created Date"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <v-text-field
                    v-validate="'required|min:3'"
                    data-vv-name="name"
                    :error-messages="errors.collect('name')"
                    v-model="item.name"
                    label="Name">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    type="number"
                    v-validate="'required|min_value:10'"
                    data-vv-name="target count"
                    :error-messages="errors.collect('target count')"
                    v-model.number="item.targetCount"
                    label="Target Count">
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <v-select
                    label="Type"
                    :items="annotationTypeCollection"
                    item-text="name"
                    item-value="id"
                    v-validate="'required'"
                    data-vv-name="annotation type"
                    :error-messages="errors.collect('annotation type')"
                    v-model="item.annotationType">
                    </v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                    label="Agreement Level"
                    :items="agreementLevelCollection"
                    item-text="name"
                    item-value="id"
                    v-validate="'required'"
                    data-vv-name="agreement level"
                    :error-messages="errors.collect('agreement level')"
                    v-model="item.agreementLevel">
                    </v-select>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <v-select
                    label="Dataset"
                    :items="datasets"
                    v-validate="'required'"
                    data-vv-name="dataset"
                    :error-messages="errors.collect('dataset')"
                    v-model="item.dataset">
                    </v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                    label="Topic Model"
                    clearable
                    :items="topicModels"
                    v-model="item.topicModel">
                    </v-select>
                  </v-flex>
                </v-layout>
              </form>
              </v-tab-item>
              <v-tab-item>
                <v-toolbar flat color="white">
                  <h4>Annotation Tasks</h4>
                  <v-spacer></v-spacer>
                  <v-btn medium depressed flat icon color="primary" :to="`/annotation-works/${this.item.id}/annotation-tasks/upload`">
                    <v-icon medium>cloud_upload</v-icon>
                  </v-btn>
                  <v-btn medium depressed flat icon color="primary" :to="`/annotation-works/${this.item.id}/annotation-tasks/add`">
                    <v-icon medium>add_circle_outline</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-data-table
                :headers="annotationTaskHeaders"
                :items="item.annotationTasks"
                :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                :loading="annotationTaskListLoading">
                  <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.id }}</td>
                    <td>{{ `${annotators[props.item.annotator].firstName} ${annotators[props.item.annotator].lastName}` }}</td>
                    <td>{{ props.item.annotationCount }}</td>
                    <td>{{ props.item.targetCount }}</td>
                    <td>{{ annotationStatusCollection[props.item.status] }}</td>
                    <td>{{ props.item.createdDate | formatDate }}</td>
                    <td class="text-xs-right">
                      <v-tooltip bottom color="grey">
                        <v-icon
                          class="mr-2"
                          color="grey"
                          slot="activator"
                          @click="exportItem(props.item)"
                        >
                          cloud_download
                        </v-icon>
                        <span>Export Annotation</span>
                      </v-tooltip>
                      <v-tooltip bottom color="secondary">
                        <v-icon
                          class="mr-2"
                          color="secondary"
                          slot="activator"
                          @click="copyToClipboard(`${annotationUrl}/${props.item.id}`)"
                          >
                          file_copy
                        </v-icon>
                        Copy execution link to clipboard
                      </v-tooltip>
                      <v-tooltip bottom color="accent">
                        <v-icon
                          class="mr-2"
                          color="accent"
                          slot="activator"
                          @click="$router.push(`/annotation-works/${item.id}/annotation-tasks/${props.item.id}/edit`)"
                        >
                          edit
                        </v-icon>
                        <span>Edit Item</span>
                      </v-tooltip>
                      <v-tooltip bottom color="error">
                        <v-icon
                          color="error"
                          slot="activator"
                          @click="deleteDialog = true; itemToDelete = props.item;"
                        >
                          delete
                        </v-icon>
                        <span>Delete Item</span>
                      </v-tooltip>
                    </td>
                  </template>
                </v-data-table>
              </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel" :disabled="saveLoading">Cancel</v-btn>
          <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(save)" :loading="saveLoading" :disabled="saveLoading" v-show="step == 0">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
  <v-dialog
        v-model="deleteDialog"
        max-width="500"
      >
        <v-card>
          <v-card-title class="headline">Delete annotation task</v-card-title>
          <v-card-text>
            Are you sure to delete this annotation task?
          </v-card-text>
          <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              flat
              depressed
              :disabled="deleteLoading"
              @click="deleteDialog = false; itemToDelete = {};"
            >
              Cancel
            </v-btn>
            <v-btn
              color="error"
              depressed
              class="white--text"
              :loading="deleteLoading"
              :disabled="deleteLoading"
              @click.native="deleteItem()"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Vue from 'vue'
export default {
  name: 'annotation-work-item',
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    },
    stepProp: {
      type: Number,
      required: false,
      default: 0
    }
  },
  created () {
    this.axios.get(`/datasets`)
      .then(response => {
        this.datasets = response.data.map((ds) => { return {text: ds.name, value: ds.id} })
        this.axios.get(`/topic-models`)
          .then(res => {
            this.topicModels = res.data.map((tm) => { return {text: tm.name, value: tm.id} })
            if (!this.isNew) {
              this.setLoader({
                loading: true
              })
              this.fetchAnnotationWork()
            }
          })
          .catch(err => {
            this.handleAxiosError(err)
          })
      })
      .catch(error => {
        this.handleAxiosError(error)
      })
  },
  data () {
    return {
      item: {
        id: '',
        name: '',
        topicModel: '',
        dataset: '',
        annotationCount: 0,
        annotationType: undefined,
        agreementLevel: undefined,
        status: 0,
        annotationTasks: []
      },
      saveLoading: false,
      deleteLoading: false,
      deleteDialog: false,
      datasets: [],
      topicModels: [],
      annotators: {},
      step: 0,
      annotationTaskListLoading: false,
      annotationTaskHeaders: [
        {text: 'ID', sortable: true, value: 'id'},
        {text: 'Annotator', sortable: true, value: 'annotator'},
        {text: 'Annotation Count', sortable: true, value: 'taskAnnotationCount'},
        {text: 'Target Count', sortable: true, value: 'taskTargetCount'},
        {text: 'Status', sortable: true, value: 'taskStatus'},
        {text: 'Created', sortable: true, value: 'taskCreatedDate'},
        {text: 'Actions', value: 'name', sortable: false, align: 'right'}
      ]
    }
  },
  computed: {
    isNew () {
      return this.id == null || this.id === ''
    },
    ...mapState({
      annotationTypeCollection: state => state.configurations.annotationTypes,
      agreementLevelCollection: state => state.configurations.agreementLevels,
      annotationStatusCollection: state => state.configurations.annotationStatusDictionary
    }),
    annotationUrl () {
      // eslint-disable-next-line no-undef
      return config ? config.VUE_APP_ANNOTATION_URL || process.env.VUE_APP_ANNOTATION_URL : process.env.VUE_APP_ANNOTATION_URL
    }
  },
  methods: {
    cancel () {
      this.$router.push('/annotation-works/')
    },
    fetchAnnotationWork () {
      this.axios.get(`/annotation-works/${this.id}`)
        .then(response => {
          this.setAnnotationWorkItem(response.data)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.setLoader({
            loading: false
          })
        })
    },
    setAnnotationWorkItem (item) {
      item = this.mapAnnotationWorkItem(item)
      this.item = item
      this.item.id = this.id
      this.item.createdDate = item.createdDate
      this.step = this.stepProp
    },
    mapAnnotationWorkItem (annotationWork) {
      return {
        name: annotationWork.name,
        dataset: annotationWork.dataset,
        targetCount: annotationWork.target_count,
        topicModel: annotationWork.topic_model,
        annotationCount: annotationWork.annotation_count,
        annotationType: annotationWork.annotation_type,
        agreementLevel: annotationWork.agreement_level,
        status: annotationWork.status,
        createdDate: Vue.options.filters.formatDate(annotationWork.created_date),
        annotationTasks: []
      }
    },
    fetchAnnotationTasks () {
      this.annotationTaskListLoading = true
      this.axios.get(`/annotators`)
        .then(r => {
          this.annotators = r.data.reduce((map, a) => {
            map[a.id] = {
              id: a.id,
              firstName: a.first_name,
              lastName: a.last_name,
              email: a.email
            }
            return map
          }, {})
          this.axios.get(`/annotation-works/${this.id}/annotation-tasks`)
            .then(res => {
              this.item.annotationTasks = res.data.map(at => ({
                id: at.id,
                annotator: at.annotator,
                targetCount: at.target_count,
                annotationCount: at.annotation_count,
                status: at.status,
                createdDate: at.created_date
              }))
            })
            .catch(err => {
              this.handleAxiosError(err)
            })
            .finally(() => {
              this.annotationTaskListLoading = false
            })
        })
        .catch(e => {
          this.handleAxiosError(e)
        })
        .finally(() => {
          this.annotationTaskListLoading = false
        })
    },
    save () {
      this.saveLoading = true
      let itemToSave = {
        name: this.item.name,
        target_count: this.item.targetCount,
        dataset: this.item.dataset,
        topic_model: this.item.topicModel || null,
        agreement_level: this.item.agreementLevel,
        annotation_type: this.item.annotationType
      }

      if (this.isNew) {
        this.axios.post('/annotation-works', itemToSave)
          .then(response => {
            this.setSnack({
              message: 'Successful',
              type: 'success'
            })
            this.item.id = response.data.id
            this.$router.replace({name: 'annotationWorkEdit', params: { id: this.item.id, stepProp: 1 }})
            this.step = 1
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else {
        this.axios.put(`/annotation-works/${this.item.id}`, itemToSave)
          .then(response => {
            this.setSnack({
              message: 'Successful',
              type: 'success'
            })
            this.$router.go(-1)
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      }
    },
    deleteItem () {
      this.deleteLoading = true
      this.axios.delete(`/annotation-works/${this.id}/annotation-tasks/${this.itemToDelete.id}`)
        .then(response => {
          let index = this.item.annotationTasks.indexOf(this.itemToDelete)
          this.item.annotationTasks.splice(index, 1)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.deleteLoading = false
          this.deleteDialog = false
          this.itemToDelete = {}
        })
    },
    copyToClipboard (text) {
      this.$copyText(text)
        .then((res) => {
          this.$toast.open({
            text: 'Copied',
            type: 'success'
          })
        })
        .catch((err) => {
          this.$toast.open({
            text: err,
            type: 'success'
          })
        })
    },
    exportItem (itemToExport) {
      this.annotationWorkListLoading = true
      if (itemToExport.annotationCount > 10000) {
        this.setSnack({
          message: 'This annotation work has more than 10000 instances. Preparing the file may take a while. Wait for downloading!',
          type: 'info',
          timeout: 4000
        })
      }

      this.axios({
        url: `/annotation-works/${this.id}/annotation-tasks/${itemToExport.id}/export/?`,
        method: 'GET',
        responseType: 'blob'
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'annotation_task.xlsx')
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          this.handleAxiosError(error)
        }).finally(() => {
          this.annotationWorkListLoading = false
        })
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack',
      setLoader: 'loader/setLoader'
    })
  },
  watch: {
    saveLoading (val) {
      this.setLoader({
        loading: val
      })
    },
    step (val) {
      if (val === 1 && !this.isNew && (!this.item.annotationTasks || this.item.annotationTasks.length === 0)) {
        this.fetchAnnotationTasks()
      }
    },
    stepProp (val) {
      this.step = val
    }
  }
}
</script>

<style>

</style>
